export enum WEBINAR_TOPICS {
    HTML_CSS = 1,
    JAVASCRIPT,
    REACT,
    BACKEND,
}
